import React from 'react';
import { Box, Container, Heading, Text, VStack, HStack, SimpleGrid } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaChartLine, FaRupeeSign } from 'react-icons/fa';

const MotionBox = motion(Box);

const ExperiencedROI = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="brand.50">
      <Container maxW="container.lg">
        <MotionBox
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Box
            p={{ base: 8, md: 12 }}
            bg="white"
            borderRadius="3xl"
            boxShadow="0 20px 60px rgba(0,0,0,0.1)"
          >
            <VStack spacing={8}>
              <VStack spacing={4} textAlign="center">
                <Heading size="2xl" fontWeight="900" color="brand.800">
                  {data.title}
                </Heading>
                <Text fontSize="lg" color="brand.500">
                  {data.description}
                </Text>
              </VStack>

              <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8} w="full">
                <VStack
                  p={6}
                  bg="brand.50"
                  borderRadius="xl"
                  spacing={3}
                >
                  <Text fontSize="sm" color="brand.500" fontWeight="600">
                    Course Investment
                  </Text>
                  <HStack>
                    <FaRupeeSign size={24} color="#10B981" />
                    <Text fontSize="3xl" fontWeight="900" color="brand.800">
                      ₹{data.investment}
                    </Text>
                  </HStack>
                  <Text fontSize="xs" color="brand.400">
                    One-time payment
                  </Text>
                </VStack>

                <VStack
                  p={6}
                  bg="accent.green"
                  borderRadius="xl"
                  spacing={3}
                  color="white"
                >
                  <Text fontSize="sm" fontWeight="600" opacity={0.9}>
                    Avg. Salary Increase
                  </Text>
                  <HStack>
                    <FaRupeeSign size={24} />
                    <Text fontSize="3xl" fontWeight="900">
                      {data.salaryIncrease}
                    </Text>
                  </HStack>
                  <Text fontSize="xs" opacity={0.8}>
                    Per year
                  </Text>
                </VStack>

                <VStack
                  p={6}
                  bg="brand.50"
                  borderRadius="xl"
                  spacing={3}
                >
                  <Text fontSize="sm" color="brand.500" fontWeight="600">
                    ROI
                  </Text>
                  <HStack>
                    <FaChartLine size={24} color="#FACC15" />
                    <Text fontSize="3xl" fontWeight="900" color="accent.gold">
                      {data.roi}
                    </Text>
                  </HStack>
                  <Text fontSize="xs" color="brand.400">
                    In first year
                  </Text>
                </VStack>
              </SimpleGrid>

              <Box
                p={6}
                bg="brand.800"
                borderRadius="xl"
                w="full"
                textAlign="center"
              >
                <Text color="white" fontSize="lg" fontWeight="600">
                  {data.averageJump}
                </Text>
              </Box>
            </VStack>
          </Box>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default ExperiencedROI;